<template>
  <div class="content-login flexs a-center j-center">
    <div class="form-login" v-if="!switchClient" v-loading="loading">
       <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
         <el-form-item :label="login.USERNAME" prop="username">
           <el-input v-model="ruleForm.username" @keyup.enter.native="$refs.password.focus()" :disabled="mfaRequired"></el-input>
         </el-form-item>
         <el-form-item :label="login.PASSWORD" prop="password">
           <el-input type="password" v-model="ruleForm.password" ref="password" autocomplete="off" @keyup.enter.native="submitForm('ruleForm',ruleForm)" :disabled="mfaRequired"></el-input>
         </el-form-item>
         <el-form-item :label="login.MFA_CODE" prop="mfa" v-if="mfaRequired">
           <el-input type="password" v-model="ruleForm.mfaToken" ref="mfaToken" autocomplete="off" @keyup.enter.native="submitForm('ruleForm',ruleForm)"></el-input>
         </el-form-item>
         <el-form-item>
           <el-button type="warning" @click="submitForm('ruleForm',ruleForm)" :disabled="mfaRequired && (ruleForm.mfaToken == null || ruleForm.mfaToken.length != 6)">{{ login.SUBMIT }}</el-button>
           <el-button @click="resetForm('ruleForm')" type="warning" plain :disabled="mfaRequired">{{ login.RESET }}</el-button>
         </el-form-item>
       </el-form>
       <div class="text-right">
         <el-dropdown trigger="click" @command="handleCommand">
           <i class="el-dropdown-link fa fa-language fa-2x" :style="{color:themeColor.header_text_color}"></i>
           <el-dropdown-menu slot="dropdown">
             <el-dropdown-item v-for="item in langList" :disabled="item.ids === selectLang" :command="item.ids" :key="item.ids">{{item.title}}</el-dropdown-item>
           </el-dropdown-menu>
         </el-dropdown>
       </div>
    </div>
    <div class="form-login" style="padding:100px 30px" v-else>
	  <span>{{ login.SWITCHING_CLIENT }}</span>
	</div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapState ,mapActions,mapMutations} from 'vuex';
  export default {
    name:'loginlogin',
    data() {
      var checkAccount = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Username cannot be empty'));
        }
        setTimeout(() => {
           callback();
        }, 1000);
      };
      var checkPass = (rule, value, callback) => {
        if (!value) {
          return callback(new Error(this.login.ERROR_EMPTY_PASSWORD));
        }
        if (value.length < 6) {
              return callback(new Error('Invalid password'));
        }
        setTimeout(() => {
           callback();
        }, 1000);
      };
      return {
        langList:[
          {ids:"zh-CN", title:"简体中文"},
          {ids:"zh-HK", title:"繁体中文"},
          {ids:"en", title:"English"},
        ],
        selectLang:"",
        ruleForm: {
          username: '',
          password: '',
          mfaToken: null
        },
        mfaRequired: false,
        rules: {
          password: [
            { validator: checkPass , trigger: 'blur' }
          ],
          username: [
            { validator: checkAccount, trigger: 'blur' },
          ],
        },
        switchClient: false,
        loading: false
      }
    },
    computed: {
      ...mapState('home',['themeColor']),
      ...mapState('auth',['profileData']),
      login() {return this.$t('login')}
    },
    components: {

    },
    created(){
      this.selectLang = localStorage.getItem('locale') || 'zh-HK';
      this.checkLogin()
    },
    methods: {
      ...mapActions('auth',['postLogin', 'getLoginCheck']),
      submitForm(formName, ruleForm) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
	          this.loading = true
            this.postLogin(ruleForm).then(result => {
              this.$router.push({name: this.$router.options.defaultRoute})
              this.$message({message: this.login.INFO_LOGIN_SUCCESS, type: 'success'});
              Sentry.setUser({ username: result.user.username, email: result.user.email });
            }).catch(error => {
              this.loading = false;
              let code = error.code;
              let message = error.message;
              if (code == '401' && message == 'MFA_REQUIRED') {
                this.mfaRequired = true;
                this.$message({message: this.login[message] ? this.login[message] : (code + ':' + message), type: 'info'});
              } else if (code == '401' && message == 'MFA_INVALID') {
                this.mfaRequired = true;
                this.ruleForm.mfaToken = null;
                this.$message({message: this.login[message] ? this.login[message] : (code + ':' + message), type: 'error'});
              } else {
                this.mfaRequired = false;
                this.ruleForm.mfaToken = null;
                this.$message({message: this.login[message] ? this.login[message] : (code + ':' + message), type: 'error'});
              }
            });
          } else {
            return false;
          }
        });
      },
      checkLogin() {
        let token = localStorage.getItem('token')
        if (token) {
          this.getLoginCheck({}).then(result => {
            Sentry.setUser({ username: result.user.username, email: result.user.email });
            this.$router.push({name: this.$router.options.defaultRoute})
          }).catch(e => {
            this.$notify.error({title: 'Session expired', message: 'Please login again.'});
          })
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleCommand(lang) {
        this.selectLang = lang ;
        localStorage.setItem('locale', lang);
        this.$i18n.locale = localStorage.getItem('locale');
        switch(lang) {
            case 'zh-CN':
              this.$message({ message: '切换为简体中文！', type: 'success' });
              break;
            case 'zh-HK':
              this.$message({ message: '切换为繁体中文！', type: 'success' });
              break;
            case 'en':
              this.$message({ message: 'Switch to English!', type: 'success' });
              break;
            default:
              break;
        }

      }
    }
  }

</script>
<style lang='stylus' scoped>
 .content-login
   height 100%;
   width 100%;
   .form-login
     width 420px
     background rgba(255,255,255,.9)
     padding 60px 40px 20px 20px
     border-radius 10px
     box-shadow 0px 0px 5px #555
     .el-button+.el-button
        margin-left 60px

</style>



// WEBPACK FOOTER //
// src/pages/login/components/login.vue